import React from 'react';
import { StyledLabel, ErrorMessageBox } from './style';
import { PhotoZone, FileLabelButton } from '../../forms/style';

export const File = ({ label, background, name, onChange, value, error }) => {
    return (
        <div>
            {label && <StyledLabel htmlFor={name}>{label}</StyledLabel>}
            <PhotoZone background={value || background}>
                <FileLabelButton htmlFor={name}>{background ? 'EDIT PHOTO' : 'ADD PHOTO'}</FileLabelButton>
                <input onChange={onChange} name={name} id={name} type={'file'} style={{ display: 'none' }} />
            </PhotoZone>
            {error && <ErrorMessageBox>{error}</ErrorMessageBox>}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/CreateEditInput/File.js